var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Box, Button, Collapse, Container, Flex, Heading, HStack, Link, Spinner, Text, VStack } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { RadioCard, RadioCardGroup } from "../components/RadioCardGroup";
import { AnswerCard } from "./answercard";
export const Wizard = (props) => {
    const [wizard, setWizard] = useState(null);
    const [loading, setLoading] = useState(true);
    const [currentStep, setCurrentStep] = useState(0);
    const [answers, setAnswers] = useState([]);
    const outcome = useMemo(() => {
        if (!wizard) {
            return null;
        }
        for (let outcome of wizard.outcomes) {
            /**
             * Cross off the rules that are matched by the given answers.
             * Since all answers have UUID we don't actually need to match them so steps,
             * they are unique anyway.
             */
            const nonMatchedRules = outcome.rules.filter((rule) => answers.indexOf(rule) === -1);
            // No unmatched rules here, this is the one
            if (nonMatchedRules.length === 0) {
                return outcome;
            }
        }
        return null;
    }, [wizard, answers]);
    useEffect(() => {
        const load = () => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield fetch("/api/wizard/" + props.wizardId);
            const data = yield response.json();
            setWizard(data);
            setLoading(false);
            setAnswers(new Array(data.steps.length).fill(null));
        });
        setLoading(true);
        load();
    }, [props.wizardId]);
    if (loading) {
        return React.createElement(Flex, { justifyContent: "center", p: 10 },
            React.createElement(Spinner, { colorScheme: "reaBlue" }));
    }
    if (!wizard) {
        return React.createElement(Spinner, { colorScheme: "reaBlue" });
    }
    return (React.createElement(Box, { as: "section", bg: "bg.surface", py: { base: '4', md: '8' } },
        React.createElement(Container, { maxW: "lg" },
            React.createElement(VStack, { w: "100%", spacing: 6, alignItems: "stretch" },
                wizard.steps.map((step, index) => (React.createElement(Collapse, { in: currentStep === index, key: step.id },
                    React.createElement(Flex, { p: 2, flexDirection: "column" },
                        React.createElement(Heading, { color: "reaBlue.800", fontSize: "lg", lineHeight: 2, mb: 3 }, step.question),
                        React.createElement(RadioCardGroup, { spacing: "3", onChange: (value) => {
                                // Replace only the current step's answer, leave all others untouched
                                setAnswers(answers.map((item, itemIndex) => itemIndex === index ? value : item));
                            } }, step.answers.map((answer) => (React.createElement(RadioCard, { key: answer.id, value: answer.id },
                            React.createElement(AnswerCard, { answer: answer }))))))))),
                React.createElement(Collapse, { in: currentStep === wizard.steps.length }, outcome ?
                    React.createElement(VStack, { spacing: 3, alignItems: "flex-start", w: "100%" },
                        React.createElement(Heading, { color: "reaBlue.800", fontSize: "lg", lineHeight: 2 }, outcome.title),
                        React.createElement(Text, null,
                            React.createElement("div", { dangerouslySetInnerHTML: { __html: outcome.description } })),
                        React.createElement(HStack, { flexWrap: "wrap", spacing: 3 }, outcome.callToActions.map((callToAction) => (React.createElement(Button, { as: Link, variant: "reaPrimary", href: callToAction.href, target: callToAction.target }, callToAction.label)))))
                    :
                        (React.createElement(React.Fragment, null,
                            React.createElement(Heading, { color: "reaBlue.800", fontSize: "lg" }, "Keine Ergebnisse"),
                            React.createElement(Text, null, "F\u00FCr Ihre Eingaben wurde kein Ergebnis gefunden.")))),
                React.createElement(Collapse, { in: currentStep !== wizard.steps.length },
                    React.createElement(Flex, { justifyContent: "space-between" },
                        React.createElement(Button, { variant: "reaSecondary", isDisabled: currentStep <= 0, onClick: () => setCurrentStep(currentStep - 1) }, "Zur\u00FCck"),
                        React.createElement(Button, { variant: "reaPrimary", isDisabled: answers[currentStep] === null, onClick: () => {
                                if (!wizard) {
                                    return;
                                }
                                const step = wizard.steps[currentStep];
                                // If the currently chosen answer is a shortcut, we go straight to outcome.
                                const chosenAnswer = step.answers.find(item => item.id === answers[currentStep]);
                                if (chosenAnswer && chosenAnswer.shortcut) {
                                    setCurrentStep(wizard === null || wizard === void 0 ? void 0 : wizard.steps.length);
                                    return;
                                }
                                setCurrentStep(currentStep + 1);
                            } }, "Weiter"))),
                React.createElement(Collapse, { in: currentStep === wizard.steps.length },
                    React.createElement(Button, { variant: "reaPrimary", mt: 6, onClick: () => setCurrentStep(0) }, "Erneut starten"))))));
};
